module.exports = __webpack_public_path__ + "media/images/front/icon_01_time-ad271d644388667b48a8b9adb034d9a5.png";